import React from "react"
import classnames from "classnames"
import styles from "./RegisterInterestForm.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import {
  InputSelect,
  FormGroup,
  InputRadio,
  InputText,
  InputEmail,
  InputCheckBox,
  Button,
  Space,
  ColumnGroup,
  Container,
  A,
  InputCaptcha
} from "AtomicComponents"
import {
  HeroContent,
  AlertList,
  Image,
  InputSearchable,
  DealerSearch
} from 'AtomicContainers'
import componentParser from "AtomicUtils/componentParser"
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formLinkSubmit, formSetDefaultValues } from "AtomicUtils/formHandler"
import MESSAGES from "AtomicConstants/MESSAGES"
import TITLES from "./TITLES"
import { DealerSearchBoxNZ } from "components"

class RegisterInterestForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        title: {
          validations: {
            required: MESSAGES.TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: MESSAGES.FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: MESSAGES.LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: MESSAGES.PHONE_NUMBER_REQUIRED
            // phone: MESSAGES.PHONE_NUMBER_INVALID
          }
        },
        email: {
          validations: {
            required: MESSAGES.EMAIL_REQUIRED,
            email: MESSAGES.EMAIL_INVALID
          }
        },
        region: {
          validations: {
            // required: MESSAGES.LOCATION_REQUIRED,
            // postcodeSearchable: MESSAGES.LOCATION_INVALID
          }
        },
        preferredDealer: {
          validations: {}
        },
        bodyStyle: {
          validations: {
          }
        },
        optedInDealer: {
          validations: {
            required: MESSAGES.OPTIN_REQUIRED
          }
        },
        privacy: {
          validations: {
            required: MESSAGES.PRIVACY_POLICY_REQUIRED
          }
        },
        reCaptcha: {
          validations: {
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    }

    if (props.bodyStyles && props.bodyStyles.length) {
      this.state.form.bodyStyle.validations = {
        required: MESSAGES.BODYSTYLE_REQUIRED
      }
    }

    if (props.isOptInMandatory) {
      this.state.form.optedInDealer.validations = {
        required: MESSAGES.OPTIN_REQUIRED
      }
    }

    if (props.showRecaptcha) {
      this.state.form.reCaptcha.validations = {
        required: MESSAGES.RECAPTCHA_REQUIRED
      }
    }
  }

  componentDidMount() {
    const { bodyStyles } = this.props

    if (bodyStyles && bodyStyles.length && bodyStyles.length === 1) {
      formSetDefaultValues(this, {
        bodyStyle: bodyStyles[0].value
      })
    }
  }

  _handleSubmit = async (event) => {
    if (event) event.preventDefault()
    const { loading, form } = this.state
    const { submitFormEndpoint, title, nameplateTitle = '', buttonText = 'Keep me informed', eloquaFormName = 'register-your-interest', source } = this.props

    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { form } = this.state
        let body = {
          nameplateTitle: nameplateTitle,
          title: form.title.value,
          firstName: form.firstName.value,
          lastName: form.lastName.value,
          phone: form.phone.value,
          email: form.email.value,
          bodyStyle: form.bodyStyle.value || null,
          optedInDealer: form.optedInDealer.value,
          eloquaFormName,
          source,
          dealerCode: form.preferredDealer.value.dealerCode,
          dealerPostCode: form.preferredDealer.value.postCode,
          state: form.preferredDealer.value.state || localStorage.getItem('selectedRegion') || ''
        }
        // if (form.region.value) body.postcode = form.region.value.postcode
        // if (form.region.value) body.state = form.region.value.state
        // if (form.region.value) body.suburb = form.region.value.suburb
        await fetchAPI({
          method: "POST",
          url: submitFormEndpoint,
          body: body
        })
        .then(async (response) => {
          const json = await response.json()
          const { success, errorMsg, words } = json
          if (!success) {
            this.setState({
              errorMessage: errorMsg,
              words: (words && words.split(",")) || [],
              loading: false
            })
          } else {
            // successful
            this.setState({
              loading: false,
              success: true
            }, () => {
              gtmHandler({
                pageCategory: `Register Your Interest Form`,
                pageAction: `Register Your Interest Form - "${nameplateTitle}" - Clicked "${buttonText}" - Successfully submitted.`
              })
            })
          }
        })
        .catch((response) => {
          this.setState({
            errorMessage: response.message || `Failed with status ${response.status}`,
            words: (response.words && response.words.split(",")) || [],
            loading: false
          })
        })
      })
    }
  }

  _handleBodyStyleChange = () => {
    const { form } = this.state

    if (form && form.bodyStyle && form.bodyStyle.value) {
      gtmHandler({
        pageCategory: "Register Your Interest Form",
        pageAction: `Register Your Interest Form - Selected "BODYSTYLE" - "${form.bodyStyle.value.toUpperCase()}"`
      })
    }
  }

  _handleOnBlurSearchableRegion = () => {
    const { form } = this.state
    if (form && form.region && form.region.value && form.region.value.description) {
      gtmHandler({
        pageCategory: "Register Your Interest Form",
        pageAction: `Register Your Interest Form - Selected "POSTCODE/SUBURB" - "${form.region.value.description.toUpperCase()}"`
      })
    }
  }

  selectDealer = (dealer) => {
    // no search, use the selected dealer only for the radio inputs
    // this.refs.dealerSearchComp._search(dealer.postCode, dealer.dealerCode)
    this.refs.dealerSearchComp.setState({
      dealers: [dealer],
      selected: dealer,
      loading: false
    })
  }

  render() {
    const {
      title,
      optInMessage,
      imageUrl,
      privacyPolicy,
      privacyPolicyLink,
      introText,
      bodyStyles,
      buttonText = 'Keep me informed',
      showRecaptcha = false,
      thankYouComponents,
      initialLocations = [],
      dealersEndPoint = "/api/dealer-search",
      dealerSearchEndPoint = "/api/dealers"
    } = this.props

    const { form, errorMessage, loading, success } = this.state

    if (success) {
      return componentParser(thankYouComponents)
    }

    return (
      <div className={classnames({
        [styles.RegisterInterest]: true }
      )}>
        {(title || introText) &&
          <HeroContent
            heading={title}
            description={introText} />
        }
        <Container styleName={imageUrl ? "tablet-wide" : "mobile"}>
          <ColumnGroup>
            <Container styleName="mobile">
              <div className={classnames({
                [styles.RegisterInterestForm]: !imageUrl
              })}>
                <form method="POST" onSubmit={this._handleSubmit} noValidate>
                  <FormGroup>
                    <InputSelect
                      name="title"
                      label="Title"
                      options={TITLES}
                      {...fromLinkInputs(this, "title")}
                      onBlur={() => {
                        if (form.title.value) {
                          gtmHandler({
                            pageCategory: "Register Your Interest Form",
                            pageAction: `Register Your Interest Form Form - Selected \"TITLE\" - ${form.title.value.toUpperCase()}`
                          })
                        }
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <InputText
                      name="firstName"
                      label="First Name"
                      {...fromLinkInputs(this, "firstName")}
                      onBlur={() => {
                        gtmHandler({
                          pageCategory: "Register Your Interest Form",
                          pageAction: "Register Your Interest Form Form - Entered \"FIRSTNAME\""
                        })
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <InputText
                      name="lastName"
                      label="Last Name"
                      {...fromLinkInputs(this, "lastName")}
                      onBlur={() => {
                        gtmHandler({
                          pageCategory: "Register Your Interest Form",
                          pageAction: "Register Your Interest Form Form - Entered \"LASTNAME\""
                        })
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <InputText
                      name="phone"
                      label="Phone"
                      {...fromLinkInputs(this, "phone")}
                      onBlur={() => {
                        gtmHandler({
                          pageCategory: "Register Your Interest Form",
                          pageAction: "Register Your Interest Form Form - Entered \"PHONE\""
                        })
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <InputEmail
                      name="email"
                      label="Email"
                      {...fromLinkInputs(this, "email")}
                      onBlur={() => {
                        gtmHandler({
                          pageCategory: "Register Your Interest Form",
                          pageAction: "Register Your Interest Form Form - Entered \"EMAIL\""
                        })
                      }}
                    />
                  </FormGroup>
                  {/* <FormGroup>
                    <InputSearchable
                      name="region"
                      type="postcode"
                      label="Postcode/Suburb"
                      {...fromLinkInputs(this, "region")}
                      onBlur={this._handleOnBlurSearchableRegion}
                    />
                  </FormGroup> */}

                  <DealerSearchBoxNZ
                    searchType="SALES"
                    noMap={true}
                    selectDealerVariant={true}
                    selectDealer={this.selectDealer}
                  />

                  <FormGroup>
                    <DealerSearch
                      dealersEndPoint={dealersEndPoint}
                      endpoint={dealerSearchEndPoint}
                      disabled={!form.region.value || !(form.region.value.postcode || form.region.value.value)}
                      type="Sales"
                      name="preferredDealer"
                      postcode={form.region.value && form.region.value.postcode || (initialLocations && initialLocations[0] && initialLocations[0].postCode)}
                      dealerCode={form.region.value && form.region.value.value}
                      ref="dealerSearchComp"
                      {...fromLinkInputs(this, "preferredDealer")} />
                  </FormGroup>

                  <FormGroup
                    hide
                    show={bodyStyles && bodyStyles.length}
                  >
                    <p className={classnames({
                      [styles.RegisterInterestFormText]: true
                    })}>
                      {
                        bodyStyles &&
                        bodyStyles.length === 1 ?
                        "The body style I am interested in is" :
                        "Tell us which body style interests you the most"
                      }
                      <span className={classnames({
                        [styles.requiredStar]: true
                      })}>*</span>
                    </p>
                    {
                      bodyStyles &&
                      bodyStyles.length &&
                      bodyStyles.map(bodyStyle => {
                        return (
                          <InputRadio
                            name="bodyStyle"
                            key={bodyStyle.value}
                            value={bodyStyle.value}
                            label={bodyStyle.name}
                            {...fromLinkInputs(this, "bodyStyle", this._handleBodyStyleChange)}
                          />
                        )
                      })
                    }
                  </FormGroup>
                  <Space />
                  <FormGroup show checkbox>
                    <InputCheckBox
                      name="optedInDealer"
                      label={optInMessage || "I understand that in registering my interest, Mazda or Mazda Dealers can send me further information about Mazda products or services."}
                      {...fromLinkInputs(this, "optedInDealer")}
                    />
                  </FormGroup>
                  <Space />
                  <FormGroup show checkbox>
                    <InputCheckBox
                      name="privacy"
                      label={
                        <span>
                          {privacyPolicy}
                          <A
                            href={privacyPolicyLink}
                            external>
                              <nobr> Privacy Policy</nobr>
                          </A>
                        </span>
                      }
                      {...fromLinkInputs(this, "privacy")}
                    />
                  </FormGroup>
                  {
                    showRecaptcha &&
                    <FormGroup>
                      <Space />
                      <InputCaptcha
                        name="reCaptcha"
                        {...fromLinkInputs(this, "reCaptcha")}
                      />
                    </FormGroup>
                  }
                  <Space />
                  <FormGroup>
                    <AlertList data={errorMessage} />
                    <Button
                      styleName="black"
                      loading={loading}
                      fullWidth
                      {...formLinkSubmit(this, this._handleSubmit)}
                    >
                      {buttonText}
                    </Button>
                  </FormGroup>
                </form>
              </div>
            </Container>
            {
              imageUrl && <Image src={imageUrl} />
            }
          </ColumnGroup>
        </Container>
      </div>
    )
  }
}

export default RegisterInterestForm



// WEBPACK FOOTER //
// ./src/AtomicContainers/RegisterInterestForm/RegisterInterestForm.jsx